<template>
  <div class="home-page">
    <div class="content">
      <HeaderSection />
      <HomeSection />
      <AboutSection />
      <ContactSection />
      <DistributionDashboard />
      <SkillsSection />
      <SubscriptionSection />
      <PortfolioSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import HeaderSection from "@/components/HeaderSection.vue";
import HomeSection from "@/components/HomeSection.vue";
import ContactSection from "@/components/ContactSection.vue";
import AboutSection from "@/components/AboutSection.vue";
import DistributionDashboard from "@/components/DistributionDashboard.vue";
import SkillsSection from "@/components/SkillsSection.vue";
import SubscriptionSection from "@/components/SubscriptionSection.vue";
import PortfolioSection from "@/components/PortfolioSection.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "HomePage",
  components: {
    HeaderSection,
    HomeSection,
    ContactSection,
    AboutSection,
    DistributionDashboard,
    SkillsSection,
    SubscriptionSection,
    PortfolioSection,
    FooterSection,
  },
};
</script>

<style src="@/styles/home-page.css"></style>

<style scoped>
.home-page { position: relative; min-height: 100vh; }
.content { position: relative; z-index: 1; } /* above the canvas */
</style>
